import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

const Select1 = (props) => {
    return (
        <div>
            <Box
                component="form"
                sx={{
                    "& .MuiTextField-root": { m: 1, width: "30ch" },
                }}
                noValidate
                autoComplete="off"
            >
                <TextField
                    id={props.id}
                    select
                    label={props.message}
                    value={props.value}
                    onChange={(e) => props.setFunction(e.target.value)}
                // helperText="Por favor escoja la zona horaria del dispositivo"
                >
                    {props.data.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Box>
        </div>
    );
};

export default Select1;
